// @ts-nocheck
import { getLocations, GetLocationFiltersApiParameter } from "@store/Framework/Services/LocationService";
import { LocationFilterModel } from "@store/Framework/Types/ApiModels";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunnerOptionalParameter,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandlerDiscreteParameter<{}, GetLocationFiltersApiParameter, LocationFilterModel[]>;

export const CancelIfAlreadyLoadingOrLoaded: HandlerType = props => {
    if (props.getState().greif.components.locationFilters.status !== "notLoaded") {
        return false;
    }
};

export const DispatchBeginLoadGreifLocations: HandlerType = props => {
    props.dispatch({
        type: "Greif/Components/LocationFilters/BeginLoadGreifLocations",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = (await getLocations(props.apiParameter)) || [];
    } catch {
        props.dispatch({
            type: "Greif/Components/LocationFilters/FailLoadGreifLocations",
        });
        return false;
    }
};

export const DispatchCompleteLoadGreifLocations: HandlerType = props => {
    props.dispatch({
        type: "Greif/Components/LocationFilters/CompleteLoadGreifLocations",
        locations: props.apiResult,
    });
};

export const chain = [
    CancelIfAlreadyLoadingOrLoaded,
    DispatchBeginLoadGreifLocations,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteLoadGreifLocations,
];

const loadGreifLocations = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadGreifLocations");
export default loadGreifLocations;
